import { MapPin, Building2, Phone, ArrowUpRight } from "lucide-react";
import { CLINIC } from "../../data/content";
import { scrollToId } from "../../lib/scroll";
import { Reveal } from "./Reveal";

const items = [
    { icon: MapPin, label: "Location", value: "Kasba, Kolkata", testid: "info-strip-location" },
    { icon: Building2, label: "Clinic", value: CLINIC.name, testid: "info-strip-clinic" },
    { icon: Phone, label: "Contact", value: CLINIC.phoneDisplay, testid: "info-strip-contact" },
];

export const InfoStrip = () => (
    <section data-testid="info-strip" className="bg-ink py-12 text-[#f8f6f0]">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 lg:flex-row lg:items-center lg:px-10">
            <div className="grid w-full grid-cols-1 gap-8 sm:grid-cols-3 lg:w-auto lg:gap-14">
                {items.map((item, i) => (
                    <Reveal key={item.label} delay={i * 0.1} className="flex items-center gap-4">
                        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-teal-300/30 bg-teal-300/10 text-teal-300">
                            <item.icon className="h-5 w-5" />
                        </span>
                        <div>
                            <p className="text-[0.65rem] font-bold uppercase tracking-[0.25em] text-teal-300/80">
                                {item.label}
                            </p>
                            <p data-testid={item.testid} className="mt-1 font-display text-lg">
                                {item.value}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.3}>
                <button
                    data-testid="info-strip-book-btn"
                    onClick={() => scrollToId("#appointment")}
                    className="group inline-flex items-center gap-2 rounded-full bg-teal-accent px-7 py-4 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-teal-500"
                >
                    Book Appointment
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                </button>
            </Reveal>
        </div>
    </section>
);
